import React, { Component } from "react";
import slackLogo from "../../../../assets/images/slack/Slack_White.svg";
import slackLightLogo from "../../../../assets/images/slack/Slack.svg";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnSlackBeginOAuthDTO from "../../../../models/DTO/IOnSlackBeginOAuthDTO";
import IOnSlackDisconnectDTO from "../../../../models/DTO/IOnSlackDisconnectDTO";
import ISlackBeginOAuthDTO from "../../../../models/DTO/ISlackBeginOAuthDTO";
import ISlackDisconnectDTO from "../../../../models/DTO/ISlackDisconnectDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    isMainViewLight?: boolean;
};

type State = {};

class SlackConnect extends Component<Props, State> {
    componentDidMount() {
        this.props.socket.on(EndpointsEnum.SlackOnBeginOAuth, this.onSlackBeginOAuth);
        this.props.socket.on(EndpointsEnum.SlackOnDisconnect, this.onDisconnect);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.SlackOnBeginOAuth, this.onSlackBeginOAuth);
        this.props.socket.removeListener(EndpointsEnum.SlackOnDisconnect, this.onDisconnect);
    }

    connect = () => {
        const payload: ISlackBeginOAuthDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SlackBeginOAuth, payload);
    };

    disconnect = () => {
        const payload: ISlackDisconnectDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SlackDisconnect, payload);
    };

    onDisconnect = (data: IOnSlackDisconnectDTO) => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onSlackBeginOAuth = (data: IOnSlackBeginOAuthDTO) => {
        window.location.href = data.url;
    };

    render() {
        let logo = slackLogo;

        if (this.props.isMainViewLight) {
            logo = slackLightLogo;
        }

        const hasSlack = !!this.props.supplierModel.Supplier_Integration.has_slack;

        return (
            <div className="SlackConnect">
                <OwAccordion
                    hideChevron={!hasSlack}
                    titleClick={hasSlack}
                    leftImage={logo}
                    leftImageHeight={50}
                    rightElem={
                        <div className={"ms-auto"}>
                            {hasSlack ? (
                                <OwBadge title={"connected"} bgColor={"bg-success"} leftIconClass={"fas fa-check"} />
                            ) : (
                                <OwButton title={"connect"} fn={this.connect} />
                            )}
                        </div>
                    }>
                    <div>
                        {hasSlack ? (
                            <div className={""}>
                                <div>
                                    <OwButton
                                        minWidth={225}
                                        className={"btn-danger"}
                                        fn={this.disconnect}
                                        leftIconClass={"fas fa-unlink"}
                                        title={"disconnect_slack"}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </OwAccordion>
            </div>
        );
    }
}

export default SlackConnect;
